import {action, extendObservable} from 'mobx';
import {FETCH_URL} from "../constants/ServerLinks";


// TODO----Rename this as Sectors, should be getting sector data from the backend with the CityId

class Sectors {

    constructor({sectors = [], sector_data = {}, roles_data = {}}, cityId) {
        extendObservable(this, sectors);
        extendObservable(this, sector_data);
        this.apiUrl = FETCH_URL + '/api/v1/sectors/?city_id=' + cityId.toString();
    }

    @action
    fetchSectors = async () => {
        const response = await fetch(`${this.apiUrl}`);
        const db_sectors = await response.json();
        console.log("From Store/sectors: " + JSON.stringify(db_sectors))
        this.sectors = db_sectors.data.sectors;
        this.sector_data = db_sectors.data.sector_data;
    };

}

export default Sectors;
